export const getPaginationRange = (currentPage: number, totalPages: number, siblingCount = 2) => {
  const totalNumbers = siblingCount * 2 + 5
  if (totalPages <= totalNumbers) {
    return Array.from({length: totalPages}, (_, i) => i + 1)
  }

  const leftSiblingIndex = Math.max(currentPage - siblingCount, 1)
  const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPages)

  const showLeftDots = leftSiblingIndex > 2
  const showRightDots = rightSiblingIndex < totalPages - 1

  const range: (number | 'dots')[] = []

  range.push(1)

  if (showLeftDots) range.push('dots')

  for (let i = leftSiblingIndex; i <= rightSiblingIndex; i++) {
    if (i !== 1 && i !== totalPages) {
      range.push(i)
    }
  }

  if (showRightDots) range.push('dots')

  if (totalPages !== 1) range.push(totalPages)

  return range
}
